import styled from 'styled-components';
import { rgba } from 'polished';

import OpenExternallyIcon from '#/assets/OpenExternallyIcon';

import { c00EE91, cFA9400, cFFFFFF } from '#/colors';

import { useParadexWebSocketStatus } from '#/features/ws/ws-context';

import { STATUS_ROUTE } from '#/routes';

interface Props {
  readonly className?: string;
}

export default function StatusBadge(props: Props) {
  const { connected } = useParadexWebSocketStatus();
  const status = connected ? 'connected' : 'disconnected';
  const title = STATUS_LABEL_MAP[status];

  return (
    <Container className={props.className}>
      <Indicator
        status={status}
        title={title}
        role="status"
        aria-label={title}
      />
      Status
      <OpenExternallyIcon size={8} />
    </Container>
  );
}

const Container = styled.a.attrs({
  href: STATUS_ROUTE,
  target: '_blank',
})`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 0;

  color: ${rgba(cFFFFFF, 0.5)};
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 11px;

  &:hover {
    color: ${rgba(cFFFFFF, 0.7)};
  }
`;

type ConnectionStatus = 'connected' | 'disconnected';

const Indicator = styled.div<{ readonly status: ConnectionStatus }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${(props) => STATUS_COLOR_MAP[props.status]};
`;

const STATUS_COLOR_MAP: Record<ConnectionStatus, string> = {
  connected: c00EE91,
  disconnected: cFA9400,
};

const STATUS_LABEL_MAP: Record<ConnectionStatus, string> = {
  connected: 'Connected',
  disconnected: 'Not connected',
};
